import { API_ENDPOINTS } from '../endpoints';

export const getAdminOrders = async (protectedClient, search, page, size) => {
    const response = await protectedClient.get(API_ENDPOINTS.ADMIN_ORDERS, {
        params: { search, page, size }
    });
    return response.data.data;
};

export const updateAdminOrders = async (protectedClient, orderId, status) => {
    const response = await protectedClient.put(API_ENDPOINTS.ADMIN_ORDERS, {orderId, status});
    return response.data;
};
